import { testimonials } from "@/mocks/testimonials";

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`text-sm ${i < rating ? "ri-star-fill text-amber-400" : "ri-star-fill text-foreground-200"}`}
        ></i>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-[#F2EFEA]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-foreground-600"></span>
            <span className="text-xs font-semibold text-foreground-600 tracking-wide uppercase">Community Verified</span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.15]">
            Trusted by Pandabuy
            <br />
            Spreadsheet Users
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            Real feedback from shoppers who use our pandabuy spreadsheet daily
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60 ${
                i === 1 ? "lg:mt-7" : ""
              }`}
            >
              <StarRating rating={t.rating} />
              <h3 className="mt-3 font-bold text-foreground-900 text-sm md:text-base">{t.title}</h3>
              <p
                className={`mt-2 text-xs md:text-sm leading-relaxed ${
                  i >= testimonials.length - 2 ? "text-foreground-400" : "text-foreground-600"
                }`}
              >
                {t.text}
              </p>
              <div className="flex items-center gap-3 mt-4 pt-3 border-t border-background-200/50">
                <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-secondary-800">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <span className="block text-xs font-semibold text-foreground-900">{t.name}</span>
                  <span className="block text-[11px] text-foreground-500">{t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}